<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item :label="$t('trailer.configurationType')">
            <!-- 配置类型 -->
            <el-select v-model="queryForm.params.configType" clearable style="width: 100%">
              <el-option key="1" :label="$t('trailer.byState')" :value="1" />
              <el-option key="2" :label="$t('trailer.byHub')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('trailer.configuredHubs')">
            <!-- 配置的网点 -->
            <el-select
              v-model="queryForm.params.siteIds"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('GlobalSetObj.status')">
            <!--状态-->
            <el-select v-model="queryForm.params.status" clearable style="width: 100%">
              <el-option key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
              <el-option key="2" :label="$t('GlobalSetObj.stop')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="margin-bottom: 15px">
          <!--搜索-->
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="enterSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh-left" size="small" type="info"
            @click="resetForm"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <el-button
            size="small" type="primary" @click="clickAdd"
          >{{ $t('GlobalSetObj.add') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        fixed="left"
        type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        :align="item.cloCenter"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'status'">
            <el-tag v-if="scope.row.status === 0" type="danger">
              {{ $t('GlobalSetObj.stop') }}
            </el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">
              {{ $t('GlobalSetObj.enable') }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'configType'">
            <div v-if="scope.row.configType === 1">
              {{ $t('trailer.byState') }}
            </div>
            <div v-if="scope.row.configType === 2">
              {{ $t('trailer.byHub') }}
            </div>
          </div>
          <div v-else class="multiline">
            {{ scope.row[item.prop] || '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('GlobalSetObj.operate')"
        align="center"
        fixed="right"
        prop="varianceNumber"
        width="110"
      >
        <template slot-scope="scope">
          <div class="flx-around">
            <i
              class="iconfont icon-a-zu255 verifier"
              style="font-size: 17px"
              @click="toEdit(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <newReturnCode ref="newReturnCodeRef" :site-list="siteList" @search="enterSearch" />
  </div>
</template>

<script>
import newReturnCode from './component/newReturnCode.vue';
import { returnCodeConfigPage } from '@/api/newExpressAPI';
import { getAllsite } from '@/api/logisticsOrders';

export default {
  name: 'ExceptionReporting',
  components: {
    newReturnCode
  },
  data() {
    return {
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          configType: '',
          siteIds: [],
          status: ''
        }
      },
      tableData: [],
      tableHeaderList: [
        {
          label: this.$t('Resource.CreationTime'),
          prop: 'createTime',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('trailer.configurationType'),
          prop: 'configType',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('trailer.configuredStates'),
          prop: 'stateCode',
          cloWidth: 140,
          cloCenter: 'center'
        },
        {
          label: this.$t('trailer.configuredHubs'),
          prop: 'siteNames',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('trailer.returnCodeValidityHours'),
          prop: 'validityHours',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.status'),
          prop: 'status',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.CreatePeople'),
          prop: 'createUserName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.editor'),
          prop: 'updateUserName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.LastModified'),
          prop: 'updateTime',
          cloWidth: 160,
          cloCenter: 'center'
        }
      ],
      siteList: []
    };
  },
  created() {
    this.getSearch();
    this.getAllSite();
  },
  methods: {
    clickAdd() {
      this.$refs.newReturnCodeRef.showEventDialog();
    },
    // 查询条件整理
    queryParam() {
      const params = {
        siteIds: this.queryForm.params.siteIds,
        configType: this.queryForm.params.configType,
        status: this.queryForm.params.status
      };
      return params;
    },
    // 查询
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {}
      };
      data.params = this.queryParam();
      returnCodeConfigPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        configType: '',
        siteIds: [],
        status: ''
      };
      this.getSearch();
    },
    // 获取所有网点
    getAllSite() {
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    toEdit(row) {
      this.$refs.newReturnCodeRef.showEventDialog(row);
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.verifier {
  color: #409eff;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
}
</style>
